import { takeLatest, put, call } from 'redux-saga/effects';

import { listCulturaCadastro } from '../service';
import {
  TABLE_CULTURA_CADASTRO,
  TABLE_CULTURA_CADASTRO_PENDING,
  TABLE_CULTURA_CADASTRO_SUCCESS,
  TABLE_CULTURA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListCulturaCadastro(action) {
  yield put({ type: TABLE_CULTURA_CADASTRO_PENDING })

  try {
    const table = yield call(listCulturaCadastro, action.args)
    yield put({ type: TABLE_CULTURA_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_CULTURA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListCulturaCadastro() {
  yield takeLatest(TABLE_CULTURA_CADASTRO, sagaListCulturaCadastro)
}